module.exports = __webpack_public_path__ + "robotboy_4-2143c8bcefd0e3592f8bb4b4a964db55.png";